import React from "react";
import { failure, success } from "../../../constants/images"
import {getPasswordQualifications, getPasswordStrength, getPasswordStrengthScore} from "../../../utils/validators";

export function PasswordRequirementsOutline({
  email, password,
}) {

  const {
    MIN_LENGTH,
    UPPER_CASE,
    LOWER_CASE,
    NUMBER,
    NON_ALPHA,
    // REPEAT_EMAIL
  } = getPasswordQualifications(password);

  const passwordMatchesEmail = password === email && password !== "";
  const passwordLengthValid = passwordMatchesEmail ? false : MIN_LENGTH
  const passwordHasUppercase = passwordMatchesEmail ? false : UPPER_CASE
  const passwordHasLowercase = passwordMatchesEmail ? false : LOWER_CASE
  const isPasswordNumber = passwordMatchesEmail ? false : NUMBER
  const passwordHasSpecialCharacter = passwordMatchesEmail ? false : NON_ALPHA
  const passwordStrengthScore = passwordMatchesEmail ? 1 : getPasswordStrengthScore(password, email)

  const label = getPasswordStrength(passwordStrengthScore)

  return (
    <div className="u--paddingSmall-bottom">
      <div className="u--paddingNone-left">
        <div className="u__bold">
          Passwords must contain:
        </div>
        <div className="password-req-entry u--paddingSmall-bottom">
          <div className="req-icon">
            {passwordLengthValid ? success : failure}
          </div>
          <span> 9 characters minimum</span>
        </div>
      </div>
      <div className="u--paddingXsmall-top u--paddingNone-left">
        <div className="u__bold">
          And 3 of the following:
        </div>
        <div className="password-req-collection u--paddingSmall-bottom">
          <div className="password-req-entry">
            <div className="req-icon">
              {passwordHasUppercase ? success : failure}
            </div>
            <span> Uppercase letter</span>
          </div>
          <div className="password-req-entry">
            <div className="req-icon">
              {isPasswordNumber ? success : failure}
            </div>
            <span> Number</span>
          </div>
          <div className="password-req-entry">
            <div className="req-icon">
              { passwordHasLowercase ? success : failure}
            </div>
            <span> Lowercase letter</span>
          </div>
          <div className="password-req-entry">
            <div className="req-icon">
              {passwordHasSpecialCharacter ? success : failure}
            </div>
            <span> Special characters</span>
          </div>
        </div>

        <div className="u--padding-bottom u__bold">
          Strength: {label}
        </div>
        <div className="strength-meter">
          <div className={`strength-meter-bar ${label.toLowerCase()}`}  />
        </div>
      </div>
      <div className="u--padding-top">
        {"Avoid repeating passwords from other websites or using phrases that might be easy to guess."}
      </div>
    </div>
  );
}

export default PasswordRequirementsOutline;